import React, { useEffect, useState } from "react";
import {
  DialogContent,
  Paper,
  InputBase,
  IconButton,
  Typography,
  Card,
  Box,
  Stack,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogActions,
  FormControl,
  Button,
  InputLabel,
  Select,
  InputAdornment,
  MenuItem,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";
import Utils from "../../core/Utils";
import ClearIcon from "@mui/icons-material/Clear";
import { Virtuoso } from "react-virtuoso";
import { connectToStore } from "../../data/store";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteOutline";

const ProductRow = React.memo(function ProductRow({
  product,
  isChecked,
  onCheckboxChange,
  countryDetails,
  isShowDelteIcon = false,
}) {
  return (
    <Card className="card p-5">
      <Stack
        direction="row"
        spacing={2}
        sx={{
          cursor: "pointer",
          "&:hover": { backgroundColor: "#f5f5f5" },
        }}
        onClick={() => {
          onCheckboxChange({ target: { checked: !isChecked } }, product.id, product)
        }
        }
      >
        {!isShowDelteIcon && <Checkbox
          alignSelf="center"
          checked={isChecked}
          onChange={(e) => onCheckboxChange(e, product.id, product)}
          onClick={(e) => e.stopPropagation()} // prevent parent click
        />}
        {isShowDelteIcon &&
          <Tooltip title="Remove" placement="bottom">
            <Button onClick={(e) =>
              onCheckboxChange({ target: { checked: !isChecked } }, product.id, product)
            } className="remove-btn">
              <DeleteForeverRoundedIcon style={{ color: "#ff0000" }} />
            </Button>
          </Tooltip>

        }

        <Stack sx={{ width: "80%" }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography fontSize="1.6rem" fontWeight="600">
              {product.shortDesc}
            </Typography>
            <Typography fontSize="1.4rem" fontWeight="600">
              {Utils.GetCurrency(product.price, countryDetails)}
            </Typography>
          </Stack>
          <Typography fontSize="13px">{product.description}</Typography>
        </Stack>
      </Stack>
    </Card>
  );
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const CustomAddProductSelection = ({
  open,
  title = "Select Items",
  overAllproducts = [],
  limit = 1000,
  onCloseProductSelection,
  visibleProducts,
  setVisibleProducts,
  categoryList,
  typeList,
  overAllTypeList,
  setTypeList = () => [],
  handleAddSelectedProducts = () => { },
  selectedIds = [],
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [servicecategory, setservicecategory] = useState("");
  const [serviceType, setserviceType] = useState("");
  const [isCustomFilter, setIsCustomFilter] = useState(false);
  const [checkedProductListIds, setCheckedProductListIds] = useState(
    () => new Set()
  );
  const [prevSelectedCount, setPrevSelectedCount] = useState(0);
  const [localSettings, setLocalSettings] = useState(connectToStore());
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [uniqueOverAllList, setUniqueOverAllList] = useState([]);
  const [uniqueTypeList, setUniqueTypeList] = useState([]);
  const [uniqueCategoryList, setUniqueCategoryList] = useState([]);

  useEffect(() => {
    setPrevSelectedCount(selectedIds.length)
    const selectedSet = new Set(selectedIds);
    const newVisible = visibleProducts.filter(
      p => !selectedSet.has(p.id)
    );
    setVisibleProducts(newVisible)
    setCheckedProductListIds(new Set());
    setSelectedProducts([]);

    filtercattyelist()

  }, [selectedIds]);


  const filtercattyelist = () => {
    console.log(overAllTypeList, typeList, categoryList)
    const UniqueOverAllListFilter = [...new Map(overAllTypeList.map(item => [
      item.toLowerCase(),   // key (case-insensitive)
      item                  // original value kept
    ])).values()];
    const UniqueTypeListFilter = [...new Map(typeList.map(item => [
      item.toLowerCase(),   // key (case-insensitive)
      item                  // original value kept
    ])).values()];
    const UniqueCategoryListFilter = [...new Map(categoryList.map(item => [
      item.toLowerCase(),   // key (case-insensitive)
      item                  // original value kept
    ])).values()];
    setUniqueOverAllList(UniqueOverAllListFilter);
    setUniqueTypeList(UniqueTypeListFilter);
    setUniqueCategoryList(UniqueCategoryListFilter);
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchValue);
    }, 200);

    return () => clearTimeout(handler);
  }, [searchValue]);

  useEffect(() => {
    if (!debouncedSearch) {
      setVisibleProducts(overAllproducts.slice(0, limit));
      setIsCustomFilter(false);
      return;
    }

    const searchText = debouncedSearch.toLowerCase();

    const filtered = overAllproducts.filter((item) => {
      return (
        (item.shortDesc && item.shortDesc.toLowerCase().includes(searchText)) ||
        (item.description &&
          item.description.toLowerCase().includes(searchText)) ||
        (item.code &&
          item.code.toString().toLowerCase().includes(searchText)) ||
        (item.hsn && item.hsn.toLowerCase().includes(searchText)) ||
        (item.department &&
          item.department.toLowerCase().includes(searchText)) ||
        (item.class && item.class.toLowerCase().includes(searchText))
      );
    });

    setVisibleProducts(filtered);
    setIsCustomFilter(true);
  }, [debouncedSearch]);

  const handleSearch = (text) => {
    setserviceType("");
    setservicecategory("");
    setSearchValue(text);
  };

  const handleFilter = (value, type) => {
    if (!Utils.IsNullOrEmpty(value) || !Utils.IsNullOrEmpty(type)) {
      var products = [];
      setSearchValue("");
      setIsCustomFilter(true);
      if (value === "" && type === "category" && serviceType === "") {
        setVisibleProducts(overAllproducts.slice(0, limit));
        setIsCustomFilter(false);
        setTypeList(overAllTypeList);
        setUniqueTypeList(uniqueOverAllList);
        return;
      }
      if (value === "" && type === "serviceType" && servicecategory === "") {
        setVisibleProducts(overAllproducts.slice(0, limit));
        setIsCustomFilter(false);
        setTypeList(overAllTypeList);
        setUniqueTypeList(uniqueOverAllList);
        return;
      }
      if (type === "category" && value !== "" && !serviceType) {
        getFilterTypes(value);
      }
      let filterdone = overAllproducts.filter((item) => {
        if (type === "serviceType" && value !== "" && servicecategory && !item.isMaterial && !item.service && !item.collection === "PackageProduct") {
          return item.class == servicecategory && item.department == value;
        } else if (type === "serviceType" && value !== "" && servicecategory && (item.isMaterial || item.service) || item.collection === "PackageProduct") {
          return item.class == servicecategory && item.fineline == value
        } else if (type === "serviceType" && value !== "" && servicecategory && !item.isMaterial && !item.service) {
          return item.class == servicecategory && item.department == value;
        } else if (type === "serviceType" && value !== "" && servicecategory && (item.isMaterial || item.service)) {
          return item.class == servicecategory && item.fineline == value
        } else if (type === "serviceType" && value !== "" && servicecategory && !item.isMaterial && !item.service) {
          return item.class == servicecategory && item.department == value;
        } else if (type === "category" && value !== "" && serviceType) {
          if (item.fineline) {
            return item.class == value && item.fineline == serviceType
          }
          return item.class == value && item.department == serviceType
        } else if (type === "category" && value === "" && serviceType) {
          return item.department == serviceType
        } else if (type === "serviceType" && value === "" && servicecategory) {
          return item.class == servicecategory;
        } else if (type === "category" && value !== "" && !serviceType) {
          return item.class == value;
        } else if (type === "serviceType" && value !== "" && !servicecategory && !item.isMaterial && !item.service) {
          return item.department == value;
        } else if (type === "serviceType" && value !== "" && !servicecategory && (item.isMaterial || item.service)) {
          return item.fineline == value;
        }
      });
      if (!Utils.IsNullOrEmptyArray(filterdone)) {
        products = filterdone;
      }
      setVisibleProducts(products);
      if (type === "category" && value === "") {
        setserviceType("");
        handleFilter("", "serviceType");
        setVisibleProducts(overAllproducts.slice(0, limit));
        setUniqueTypeList(uniqueOverAllList)
      }
    }
  };

  const getFilterTypes = (categoryValue) => {
    let newArr = [];
    overAllproducts.map((product) => {
      if (
        product.class === categoryValue &&
        product.department &&
        !product.isMaterial &&
        !product.service
      ) {
        newArr.push(product.department);
      }
      if (
        product.class === categoryValue &&
        product.fineline &&
        (product.isMaterial ||
          product.service ||
          product.collection === "PackageProduct")
      ) {
        newArr.push(product.fineline);
      }
    });
    const uniqueNewArr = newArr.filter(
      (item, index, self) =>
        index === self.findIndex(
          (t) => t.toLowerCase() === item.toLowerCase()
        )
    );
    setUniqueTypeList(uniqueNewArr);
  };

  const onCheckboxChange = (e, productId, product) => {
    setCheckedProductListIds((prev) => {
      const updated = new Set(prev); // clone once (cheap)
      if (e.target.checked) {
        updated.add(productId);
        setSelectedProducts((prev) => [...prev, product])
      } else {
        updated.delete(productId);
        setSelectedProducts((prev) => prev.filter((p) => p.id !== productId));
      }
      return updated;
    });
  };



  const clearFiltersSearch = () => {
    setservicecategory("");
    setserviceType("");
    setSearchValue("");
  }

  const handleAddProducts = () => {
    handleAddSelectedProducts(checkedProductListIds);
    clearFiltersSearch()
    onCloseProductSelection();
  };

  return (
    <BootstrapDialog
      aria-labelledby="customized-dialog-title"
      className="cs-modal-sec"
      open={open}
      PaperProps={{
        style: { width: "70%", maxWidth: "90%" },
      }}
    >
      {/* ------- Title -------- */}
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={() => { onCloseProductSelection(); clearFiltersSearch() }}
      >
        <Typography
          level="h3"
          component="h3"
          fontWeight="600"
          fontSize="2rem"
          className="h3"
        >
          {title}
        </Typography>
      </BootstrapDialogTitle>

      {/* ------- Content Area -------- */}
      <DialogContent
        dividers
        className="modal-dialog-content"
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "70vh", // fixed height for dialog
          padding: "16px !important",
        }}
      >


        {/* ------- List Area -------- */}
        <Stack direction="row" spacing={2} sx={{ height: "100%" }}>
          <Box
            sx={{
              padding: 2,
              height: "100%",
              overflow: "hidden", // Virtuoso handles scroll
              marginTop: 1,
              flexGrow: 1,
            }}
            className="card white-bg"
          >

            <Stack direction="row"
              component="form"
              sx={{
                width: "100%",
              }}
              className="font-size-14"
              mb={2}
            >
              <Stack direction="row" spacing={2} alignItems="center" width="100%">
                {/* Category */}
                <FormControl fullWidth className="font-size-14">
                  <InputLabel id="category-label">Category</InputLabel>
                  <Select
                    label="Category"
                    labelId="category-label"
                    value={servicecategory}
                    title={servicecategory}
                    onChange={(e) => {
                      setservicecategory(e.target.value);
                      handleFilter(e.target.value, "category");
                    }}
                    endAdornment={
                      servicecategory && (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              setservicecategory("");
                              handleFilter("", "category");
                            }}
                            edge="end"
                            size="small"
                          >
                            <ClearIcon />
                          </IconButton>
                        </InputAdornment>
                      )
                    }
                    sx={{ fontSize: "1.2rem" }}
                  >
                    {!Utils.IsNullOrEmptyArray(uniqueCategoryList) &&
                      uniqueCategoryList.map((item) => (
                        <MenuItem value={item}>{item}</MenuItem>
                      ))}
                  </Select>
                </FormControl>

                {/* Type */}
                <FormControl fullWidth className="font-size-14">
                  <InputLabel id="type-label">Type</InputLabel>
                  <Select
                    label="Type"
                    labelId="type-label"
                    value={serviceType}
                    title={serviceType}
                    onChange={(e) => {
                      setserviceType(e.target.value);
                      handleFilter(e.target.value, "serviceType");
                    }}
                    endAdornment={
                      serviceType && (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              setserviceType("");
                              handleFilter("", "serviceType");
                            }}
                            edge="end"
                            size="small"
                          >
                            <ClearIcon />
                          </IconButton>
                        </InputAdornment>
                      )
                    }
                    sx={{ fontSize: "1.2rem" }}
                  >
                    {!Utils.IsNullOrEmptyArray(uniqueTypeList) &&
                      uniqueTypeList.map((item) => (
                        <MenuItem value={item}>{item}</MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Stack>
            </Stack>

            {/* ------- Search Bar -------- */}
            <Paper
              component="form"
              sx={{
                p: "2px",
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: 2,
              }}
              className="font-size-16"
            >
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder="Search Items"
                value={searchValue}
                onChange={(e) => handleSearch(e.target.value)}
              />
              {searchValue && (
                <IconButton
                  sx={{ p: "10px" }}
                  aria-label="clear"
                  onClick={() => handleSearch("")}
                >
                  <ClearIcon />
                </IconButton>
              )}
              <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
                <SearchIcon />
              </IconButton>
            </Paper>

            <Virtuoso
              style={{ height: "70%" }}
              totalCount={visibleProducts.length}
              overscan={200} // renders extra rows for smooth scroll
              itemContent={(index) => {
                const product = visibleProducts[index];
                const isChecked = checkedProductListIds.has(product.id);

                return (
                  <Box mb={1} key={product.id}>
                    <ProductRow
                      key={product.id}
                      product={product}
                      isChecked={isChecked}
                      onCheckboxChange={onCheckboxChange}
                      countryDetails={localSettings.country}
                    />
                  </Box>
                );
              }}
              endReached={() => {
                if (
                  !isCustomFilter &&
                  visibleProducts.length < overAllproducts.length
                ) {
                  const nextLimit = visibleProducts.length + limit;
                  const nextBatch = overAllproducts.slice(
                    visibleProducts.length,
                    nextLimit
                  );
                  setVisibleProducts((prev) => [...prev, ...nextBatch]);
                }
              }}
              components={{
                Footer: () =>
                  !isCustomFilter && visibleProducts.length < overAllproducts.length ? (
                    <Box py={2} textAlign="center">
                      <Typography>Loading...</Typography>
                    </Box>
                  ) : null,
              }}
            />
          </Box>
          <Box
            sx={{
              padding: 2,
              height: "100%",
              overflow: "hidden", // Virtuoso handles scroll
              marginTop: 1,
              flexGrow: 1,
            }}
            className="card white-bg"
          >
            <Typography
              level="h4"
              component="h4"
              fontWeight="600"
              fontSize="2rem"
              className="h3"
              mb
            >Selected Items</Typography>
            <Virtuoso
              style={{ height: "90%" }}
              totalCount={selectedProducts.length}
              overscan={200} // renders extra rows for smooth scroll
              itemContent={(index) => {
                const product = selectedProducts[index];
                const isChecked = checkedProductListIds.has(product.id);
                return (
                  <Box mb={1} key={product.id}>
                    <ProductRow
                      key={product.id}
                      product={product}
                      isChecked={isChecked}
                      onCheckboxChange={onCheckboxChange}
                      countryDetails={localSettings.country}
                      isShowDelteIcon={true}
                    />
                  </Box>
                );

              }}
            />
          </Box>
        </Stack>


        <Stack direction="row"
          style={{
            paddingTop: "15px",
            justifyContent: "flex-end",
          }}
          spacing={2}
        >
          <FormControl>
            <Button
              type="submit"
              variant="contained"
              className="btn btn-secondary"
              onClick={() => { onCloseProductSelection(); clearFiltersSearch() }}
            >
              Cancel
            </Button>
          </FormControl>
          <FormControl>
            <Button
              type="submit"
              variant="contained"
              className="btn btn-primary"
              onClick={() => handleAddProducts()}
              disabled={checkedProductListIds.size === 0}
            >
              {(checkedProductListIds.size)
                ? `Add (${(checkedProductListIds.size)})`
                : "Add"}
            </Button>
          </FormControl>
        </Stack>
      </DialogContent>
    </BootstrapDialog>
  );
};

export default CustomAddProductSelection;
